<div class="tab-pane active container-fluid" role="tabpanel" aria-labelledby="parameters-tab">
	<div class="table-responsive mt-3" *ngIf="cropParameters">
		<table class="table table-striped table-bordered table-curved table-fit table-fixed" [title]="tableTooltip">
			<thead>
			<tr>
				<th><span jhiTranslate="crop-settings-manager.parameters.columns.key"></span></th>
				<th><span jhiTranslate="crop-settings-manager.parameters.columns.value"></span></th>
				<th><span jhiTranslate="crop-settings-manager.parameters.columns.description"></span></th>
			</tr>
			</thead>
			<tbody>
			<tr *ngFor="let cropParameter of cropParameters; index as index">
				<td>
					{{cropParameter.key}}
					<div class="float-end" *ngIf="cropParameter.encrypted && !editing[index]">
							<span [ngClass]="(showEncryptedText[index] ? 'fa pl-1 fa-eye' : 'fa pl-1 fa-eye-slash')"
								  [title]="encryptedValueTooltip"
								  (click)="toggleEncryptedValueDisplay(index)"></span>
					</div>
				</td>
				<td class="editable">
					<jhi-inline-editor [observationVariable]="characterVariable"
									   [value]="cropParameter.value"
									   [isEncrypted]="cropParameter.encrypted && !showEncryptedText[index]"
									   (onApply)="submit($event, index, cropParameter)"
									   (onCancel)="cancel(index, cropParameter)"
									   [(editing)]="editing[index]">
						<span><!-- filler -->&nbsp;</span>
						{{cropParameter.encrypted ? getEncryptedValueDisplay(cropParameter.value, index) : cropParameter.value}}
					</jhi-inline-editor>
				</td>
				<td>{{ cropParameter.description | translate }}</td>
			</tr>
			</tbody>
		</table>
	</div>
</div>
